// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"beed6795","732":"5c976f2b"}[chunkId] + ".chunk.js";
};